module.exports = __webpack_public_path__ + "static/img/search_blank.5d094b7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/search_blank.png
// module id = MULH
// module chunks = 1